/**
 * Generated by orval v7.9.0 🍺
 * Do not edit manually.
 * MovingWorlds API
 * OpenAPI spec version: 0.1.0
 */
import { useMutation, useQuery } from '@tanstack/react-query';
import type {
  DataTag,
  DefinedInitialDataOptions,
  DefinedUseQueryResult,
  MutationFunction,
  QueryClient,
  QueryFunction,
  QueryKey,
  UndefinedInitialDataOptions,
  UseMutationOptions,
  UseMutationResult,
  UseQueryOptions,
  UseQueryResult,
} from '@tanstack/react-query';

import type {
  ActionUpdateRequest,
  GetProjectHubDataParams,
  GetTeamProjectHubDataParams,
  HTTPValidationError,
  PlanUpdateRequest,
  ProjectHubResponse,
  TeamProjectHubResponse,
} from './platformapi.schemas';

import postActionUpdateMutator from '../custom-axios-instance';
import getProjectHubDataMutator from '../custom-axios-instance';
import postPlanUpdateMutator from '../custom-axios-instance';
import getTeamProjectHubDataMutator from '../custom-axios-instance';

/**
 * Posts a project work update with provided project and the auth session user id
 * @summary Post Action Update
 */
export const postActionUpdate = (
  actionUpdateRequest: ActionUpdateRequest,
  signal?: AbortSignal,
) => {
  return postActionUpdateMutator<unknown>({
    url: `${import.meta.env['VITE_API_HOST']}/project-hub/action-update`,
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    data: actionUpdateRequest,
    signal,
  });
};

export const getPostActionUpdateMutationOptions = <
  TError = HTTPValidationError,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof postActionUpdate>>,
    TError,
    { data: ActionUpdateRequest },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof postActionUpdate>>,
  TError,
  { data: ActionUpdateRequest },
  TContext
> => {
  const mutationKey = ['postActionUpdate'];
  const { mutation: mutationOptions } =
    options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
        options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey } };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof postActionUpdate>>,
    { data: ActionUpdateRequest }
  > = (props) => {
    const { data } = props ?? {};

    return postActionUpdate(data);
  };

  return { mutationFn, ...mutationOptions };
};

export type PostActionUpdateMutationResult = NonNullable<
  Awaited<ReturnType<typeof postActionUpdate>>
>;
export type PostActionUpdateMutationBody = ActionUpdateRequest;
export type PostActionUpdateMutationError = HTTPValidationError;

/**
 * @summary Post Action Update
 */
export const usePostActionUpdate = <TError = HTTPValidationError, TContext = unknown>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof postActionUpdate>>,
      TError,
      { data: ActionUpdateRequest },
      TContext
    >;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof postActionUpdate>>,
  TError,
  { data: ActionUpdateRequest },
  TContext
> => {
  const mutationOptions = getPostActionUpdateMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};
/**
 * Fetches all data required to render project hub for individual assignments
 * @summary Get Project Hub Data
 */
export const getProjectHubData = (params: GetProjectHubDataParams, signal?: AbortSignal) => {
  return getProjectHubDataMutator<ProjectHubResponse>({
    url: `${import.meta.env['VITE_API_HOST']}/project-hub/individual`,
    method: 'GET',
    params,
    signal,
  });
};

export const getGetProjectHubDataQueryKey = (params: GetProjectHubDataParams) => {
  return [
    `${import.meta.env['VITE_API_HOST']}/project-hub/individual`,
    ...(params ? [params] : []),
  ] as const;
};

export const getGetProjectHubDataQueryOptions = <
  TData = Awaited<ReturnType<typeof getProjectHubData>>,
  TError = HTTPValidationError,
>(
  params: GetProjectHubDataParams,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getProjectHubData>>, TError, TData>>;
  },
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetProjectHubDataQueryKey(params);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getProjectHubData>>> = ({ signal }) =>
    getProjectHubData(params, signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getProjectHubData>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData> };
};

export type GetProjectHubDataQueryResult = NonNullable<
  Awaited<ReturnType<typeof getProjectHubData>>
>;
export type GetProjectHubDataQueryError = HTTPValidationError;

export function useGetProjectHubData<
  TData = Awaited<ReturnType<typeof getProjectHubData>>,
  TError = HTTPValidationError,
>(
  params: GetProjectHubDataParams,
  options: {
    query: Partial<UseQueryOptions<Awaited<ReturnType<typeof getProjectHubData>>, TError, TData>> &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getProjectHubData>>,
          TError,
          Awaited<ReturnType<typeof getProjectHubData>>
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
export function useGetProjectHubData<
  TData = Awaited<ReturnType<typeof getProjectHubData>>,
  TError = HTTPValidationError,
>(
  params: GetProjectHubDataParams,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getProjectHubData>>, TError, TData>> &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getProjectHubData>>,
          TError,
          Awaited<ReturnType<typeof getProjectHubData>>
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
export function useGetProjectHubData<
  TData = Awaited<ReturnType<typeof getProjectHubData>>,
  TError = HTTPValidationError,
>(
  params: GetProjectHubDataParams,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getProjectHubData>>, TError, TData>>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
/**
 * @summary Get Project Hub Data
 */

export function useGetProjectHubData<
  TData = Awaited<ReturnType<typeof getProjectHubData>>,
  TError = HTTPValidationError,
>(
  params: GetProjectHubDataParams,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getProjectHubData>>, TError, TData>>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {
  const queryOptions = getGetProjectHubDataQueryOptions(params, options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData>;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * Posts a project update with provided project and the auth session user id
 * @summary Post Plan Update
 */
export const postPlanUpdate = (planUpdateRequest: PlanUpdateRequest, signal?: AbortSignal) => {
  return postPlanUpdateMutator<unknown>({
    url: `${import.meta.env['VITE_API_HOST']}/project-hub/plan-update`,
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    data: planUpdateRequest,
    signal,
  });
};

export const getPostPlanUpdateMutationOptions = <
  TError = HTTPValidationError,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof postPlanUpdate>>,
    TError,
    { data: PlanUpdateRequest },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof postPlanUpdate>>,
  TError,
  { data: PlanUpdateRequest },
  TContext
> => {
  const mutationKey = ['postPlanUpdate'];
  const { mutation: mutationOptions } =
    options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
        options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey } };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof postPlanUpdate>>,
    { data: PlanUpdateRequest }
  > = (props) => {
    const { data } = props ?? {};

    return postPlanUpdate(data);
  };

  return { mutationFn, ...mutationOptions };
};

export type PostPlanUpdateMutationResult = NonNullable<Awaited<ReturnType<typeof postPlanUpdate>>>;
export type PostPlanUpdateMutationBody = PlanUpdateRequest;
export type PostPlanUpdateMutationError = HTTPValidationError;

/**
 * @summary Post Plan Update
 */
export const usePostPlanUpdate = <TError = HTTPValidationError, TContext = unknown>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof postPlanUpdate>>,
      TError,
      { data: PlanUpdateRequest },
      TContext
    >;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof postPlanUpdate>>,
  TError,
  { data: PlanUpdateRequest },
  TContext
> => {
  const mutationOptions = getPostPlanUpdateMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};
/**
 * Fetches all data required to render project hub for team assignments
 * @summary Get Team Project Hub Data
 */
export const getTeamProjectHubData = (
  params: GetTeamProjectHubDataParams,
  signal?: AbortSignal,
) => {
  return getTeamProjectHubDataMutator<TeamProjectHubResponse>({
    url: `${import.meta.env['VITE_API_HOST']}/project-hub/team`,
    method: 'GET',
    params,
    signal,
  });
};

export const getGetTeamProjectHubDataQueryKey = (params: GetTeamProjectHubDataParams) => {
  return [
    `${import.meta.env['VITE_API_HOST']}/project-hub/team`,
    ...(params ? [params] : []),
  ] as const;
};

export const getGetTeamProjectHubDataQueryOptions = <
  TData = Awaited<ReturnType<typeof getTeamProjectHubData>>,
  TError = HTTPValidationError,
>(
  params: GetTeamProjectHubDataParams,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getTeamProjectHubData>>, TError, TData>
    >;
  },
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetTeamProjectHubDataQueryKey(params);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getTeamProjectHubData>>> = ({ signal }) =>
    getTeamProjectHubData(params, signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getTeamProjectHubData>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData> };
};

export type GetTeamProjectHubDataQueryResult = NonNullable<
  Awaited<ReturnType<typeof getTeamProjectHubData>>
>;
export type GetTeamProjectHubDataQueryError = HTTPValidationError;

export function useGetTeamProjectHubData<
  TData = Awaited<ReturnType<typeof getTeamProjectHubData>>,
  TError = HTTPValidationError,
>(
  params: GetTeamProjectHubDataParams,
  options: {
    query: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getTeamProjectHubData>>, TError, TData>
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getTeamProjectHubData>>,
          TError,
          Awaited<ReturnType<typeof getTeamProjectHubData>>
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
export function useGetTeamProjectHubData<
  TData = Awaited<ReturnType<typeof getTeamProjectHubData>>,
  TError = HTTPValidationError,
>(
  params: GetTeamProjectHubDataParams,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getTeamProjectHubData>>, TError, TData>
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getTeamProjectHubData>>,
          TError,
          Awaited<ReturnType<typeof getTeamProjectHubData>>
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
export function useGetTeamProjectHubData<
  TData = Awaited<ReturnType<typeof getTeamProjectHubData>>,
  TError = HTTPValidationError,
>(
  params: GetTeamProjectHubDataParams,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getTeamProjectHubData>>, TError, TData>
    >;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
/**
 * @summary Get Team Project Hub Data
 */

export function useGetTeamProjectHubData<
  TData = Awaited<ReturnType<typeof getTeamProjectHubData>>,
  TError = HTTPValidationError,
>(
  params: GetTeamProjectHubDataParams,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getTeamProjectHubData>>, TError, TData>
    >;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {
  const queryOptions = getGetTeamProjectHubDataQueryOptions(params, options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData>;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}
